import { Skeleton } from '@mui/material';
import { ReactComponent as StarLoader } from 'images/icons/StarLoader.svg';
import './CertificateLoaderCard.scss';

export const CertificateLoaderCard = () => {
  return (
    <div className='certificate-loader-card'>
      <StarLoader />
      <Skeleton width={100} height={13} />
      <div>
        <Skeleton width={250} height={13} />
        <Skeleton width={200} height={13} />
      </div>
      <Skeleton width={100} height={13} />
    </div>
  );
};
